import React from "react";
import { styled } from '@mui/material/styles';

const PublicLayout = ({ children }) => {
  return <RootWrapper>{children}</RootWrapper>;
};

const RootWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100vh',
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  backgroundSize: 'cover',
}))

export default PublicLayout;
